module.exports = __webpack_public_path__ + "static/assets/9844f07238b57b2a35cf880055fcec35.gif";